import React, {useEffect, useState} from "react"
// data
import Cart from "../../../data/cart"

// styling
import "./Addresses.scss"

/**
 * Renders read-only payment and shipping addresses
 */
function Addresses() {
  const [addresses, setAddresses] = useState([])

  useEffect(() => {
    let arr = []
    let pa = Cart.getPaymentAddress()
    arr.push({
      title:Cart.getShippingIsDifferent() ? "Rechnungsadresse" : "Rechnungs- & Versandadresse",
      lines:[
        `${pa.ClientFirstName} ${pa.ClientName}`,
        pa.ClientCompany,
        pa.ClientAddress,
        pa.ClientAddress2,
        `${pa.ClientZip} ${pa.ClientCity}`,
        pa.ClientEmail
      ].filter(l => (l || "").trim().length > 0)
    })
    if(Cart.getShippingIsDifferent()) {
      let sa = Cart.getShippingAddress()
      arr.push({
        title:"Versandadresse",
        lines:[
          `${sa.ShippingFirstName} ${sa.ShippingName}`,
          sa.ShippingCompany,
          sa.ShippingAddress,
          sa.ShippingAddress2,
          `${sa.ShippingZip} ${sa.ShippingCity}`
        ].filter(l => (l || "").trim().length > 0)
      })
    }
    setAddresses(arr)
  }, [])
  
  let items = addresses.map(a => {
    let lines = a.lines.map((l, index) => {
      return <p key={index}>{l}</p>
    })
    return (
      <div key={a.title} className="address">
        <div className="title">{a.title}</div>
        {lines}
      </div>
    )
  })
  
  return (
    <div id="v-addresses">
      {items}
    </div>
  )
}

export default Addresses